import { render, staticRenderFns } from "./OpcionesBloqueos.vue?vue&type=template&id=216191cb"
import script from "./OpcionesBloqueos.vue?vue&type=script&lang=js"
export * from "./OpcionesBloqueos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports